export const mockData = {
  company: {
    name: "GreenZaar",
    tagline: "Premium Guar Gum Solutions",
    description: "Leading supplier of high-quality Guar Gum products serving industries across USA and India with over 15 years of expertise.",
    locations: ["USA", "India"],
    email: "admin@greenzaar.com",
    addresses: {
      usa: {
        street: "1021 E Lincolnway",
        suite: "Suit 9068",
        city: "Cheyenne",
        state: "WY",
        zip: "82001",
        country: "USA"
      },
      india: {
        street: "First Floor, War no 14, Bikaner Road",
        city: "Sardarsahar",
        district: "Churu",
        state: "Rajasthan",
        pin: "331403",
        country: "India"
      }
    },
    phones: {
      usa: "+1 (217) 253-9960",
      india: "+91 7840860200"
    },
    social: {
      twitter: "https://x.com/GreenZaar1",
      linkedin: "https://www.linkedin.com/in/greenzaar-llc-6127b5387/"
    }
  },
  
  hero: {
    title: "Premium Guar Gum for Industrial Excellence",
    subtitle: "Trusted by leading manufacturers worldwide for consistent quality and reliable supply",
    features: [
      "ISO 9001:2015 Certified",
      "FDA Approved Facilities",
      "Global Supply Chain"
    ]
  },
  
  products: {
    title: "Our Guar Gum Products",
    items: [
      {
        name: "Food Grade Guar Gum",
        description: "Premium quality guar gum for food and beverage applications",
        applications: ["Thickening Agent", "Stabilizer", "Emulsifier"],
        purity: "99.5%+",
        mesh: "200-300"
      },
      {
        name: "Industrial Grade Guar Gum",
        description: "High-performance guar gum for industrial applications", 
        applications: ["Oil Drilling", "Textile Printing", "Paper Industry"],
        viscosity: "5000-6000 cPs",
        mesh: "100-200"
      },
      {
        name: "Pharmaceutical Grade",
        description: "USP/BP compliant guar gum for pharmaceutical use",
        applications: ["Tablet Binder", "Controlled Release", "Suspensions"],
        purity: "99.8%+",
        compliance: "USP/BP Standards"
      }
    ]
  },
  
  applications: {
    title: "Industries We Serve",
    sectors: [
      {
        name: "Food & Beverage",
        description: "Natural thickening and stabilizing agent for food products",
        uses: ["Ice Cream", "Sauces", "Bakery Products", "Dairy"]
      },
      {
        name: "Oil & Gas",
        description: "High-performance drilling fluid additive for enhanced operations",
        uses: ["Hydraulic Fracturing", "Drilling Fluids", "Completion Fluids"]
      },
      {
        name: "Textile Industry",
        description: "Superior printing paste thickener for textile applications",
        uses: ["Printing Paste", "Sizing Agent", "Finishing"]
      },
      {
        name: "Pharmaceuticals",
        description: "Pharmaceutical grade excipient for drug formulations",
        uses: ["Tablet Binding", "Controlled Release", "Suspensions"]
      },
      {
        name: "Paper & Pulp",
        description: "Eco-friendly additive for paper manufacturing processes",
        uses: ["Wet Strength", "Surface Treatment", "Coating"]
      },
      {
        name: "Cosmetics",
        description: "Natural thickening agent for cosmetic formulations",
        uses: ["Lotions", "Creams", "Gels", "Shampoos"]
      }
    ]
  },
  
  certifications: [
    {
      name: "ISO 9001:2015",
      description: "Quality Management System",
      authority: "International Organization for Standardization"
    },
    {
      name: "FDA Registration",
      description: "Food and Drug Administration Approved",
      authority: "US Food and Drug Administration"
    },
    {
      name: "FSSAI License",
      description: "Food Safety and Standards Authority of India",
      authority: "Government of India"
    },
    {
      name: "HACCP Certified",
      description: "Hazard Analysis Critical Control Points",
      authority: "Food Safety Management"
    }
  ],
  
  qualityFeatures: [
    {
      title: "Consistent Quality",
      description: "Rigorous quality control ensures batch-to-batch consistency"
    },
    {
      title: "Global Supply Chain",
      description: "Reliable delivery network across USA and India"
    },
    {
      title: "Technical Support",
      description: "Expert technical assistance for optimal product application"
    },
    {
      title: "Custom Solutions",
      description: "Tailored guar gum specifications to meet specific requirements"
    }
  ],
  
  testimonials: [
    {
      company: "Global Foods Inc.",
      feedback: "GreenZaar's guar gum has consistently met our quality standards for over 5 years. Their reliability is unmatched.",
      industry: "Food Manufacturing"
    },
    {
      company: "PetroTech Solutions",
      feedback: "Excellent viscosity performance and technical support. Our go-to supplier for drilling applications.",
      industry: "Oil & Gas"
    },
    {
      company: "Pharma Dynamics",
      feedback: "USP grade quality with complete documentation. Perfect for our pharmaceutical formulations.",
      industry: "Pharmaceuticals"
    }
  ],
  
  navigation: [
    { name: "Home", href: "#home" },
    { name: "Products", href: "#products" },
    { name: "Applications", href: "#applications" },
    { name: "Quality", href: "#quality" },
    { name: "About", href: "#about" },
    { name: "Contact", href: "#contact" }
  ]
};